import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Field, reduxForm } from 'redux-form';
import { ControlLabel } from 'react-bootstrap';
import ModalForm from 'components/ModalForm';
import classNames from 'classnames';
import styles from './styles.css';
import messages from './messages';

const ReopenTransferForm = ({ handleSubmit, show, onHide }) => (
  <ModalForm
    onHide={onHide}
    show={show}
    handleSubmit={handleSubmit}
    title={<FormattedMessage {...messages.reopenTransfer} />}
    submitLabel={<FormattedMessage {...messages.submit} />}
  >
    <p className={classNames(styles.confirmWarning, 'alert-danger')}><FormattedMessage {...messages.confirmWarning} /></p>
    <ControlLabel htmlFor="comment" className={styles.commentLabel}>
      <FormattedMessage {...messages.comment} />
      <Field
        required
        name="comment"
        component="textarea"
        className="form-control"
      />
    </ControlLabel>
  </ModalForm>
);


ReopenTransferForm.propTypes = {
  onHide: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  handleSubmit: PropTypes.func.isRequired,
};

export default reduxForm({ form: 'ReopenTransfer', enableReinitialize: true })(ReopenTransferForm);



// WEBPACK FOOTER //
// ./src/components/ReopenTransferForm/index.js